import store from '@/store'

export const createPlayer = ({ element, key, playlist, events }) => {
  if (!key) {
    throw new Error('Must supply a jwplayer API key')
  }
  if (!element) {
    throw new Error('Must supply a valid html element ID')
  }
  if (!playlist) {
    throw new Error('Must supply a valid video playlist')
  }

  const isMuted = () => {
    return store?.state?.app?.videoPlaybackPreferences?.isMuted ?? false
  }

  const rate = () => {
    return store?.state?.app?.videoPlaybackPreferences?.playbackSpeed ?? 1
  }

  const prefersFullscreen = () => {
    return store?.state?.app?.videoPlaybackPreferences?.isFullscreen ?? false
  }

  const preferredVolume = () => {
    return store?.state?.app?.videoPlaybackPreferences?.volume ?? 90
  }

  const player = jwplayer(element)

  if (!player.setup) {
    throw new Error('No Player found')
  }

  player.setup({
    key,
    displaytitle: true,
    logo: true,
    playlist,
    width: '100%',
    cast: {},
    floating: {},
    mute: false,
    aspectratio: '16:9',
    visualplaylist: false,
    controls: true,
    autostart: true,
    playbackRateControls: [0.75, 1, 1.25, 1.5, 2, 2.5, 3],
  })
  const defaultEvents = {
    fullscreen: e => {
      store.commit('app/VIDEO_PLAYBACK_PREFERENCES_UPDATED', {
        preference: 'isFullscreen',
        value: e?.fullscreen ?? false,
      })
    },
    mute: e => {
      store.commit('app/VIDEO_PLAYBACK_PREFERENCES_UPDATED', {
        preference: 'isMuted',
        value: e?.mute ?? false,
      })
    },
    play: () => {
      if (prefersFullscreen() && !player.getFullscreen()) {
        player.setFullscreen()
      }
      player.setPlaybackRate(rate())
      player.setMute(isMuted())
      if (!player.getMute()) {
        player.setVolume(preferredVolume())
      }
    },
    playbackRateChanged: e => {
      store.commit('app/VIDEO_PLAYBACK_PREFERENCES_UPDATED', {
        preference: 'playbackSpeed',
        value: e?.playbackRate ?? 1,
      })
    },
    volume: e => {
      store.commit('app/VIDEO_PLAYBACK_PREFERENCES_UPDATED', {
        preference: 'volume',
        value: e?.volume ?? 90,
      })
    },
  }
  if (events) {
    if (!events.fullscreen) {
      events.fullscreen = e => defaultEvents.fullscreen.call(null, e)
    } else {
      const passedCallback = events.fullscreen
      delete events.fullscreen
      events.fullscreen = e => {
        defaultEvents.fullscreen.call(null, e)
        passedCallback.call(null, e)
      }
    }
    events.mute = e => {
      defaultEvents.mute.call(null, e)
    }
    if (!events.play) {
      events.play = e => defaultEvents.play.call(null, e)
    } else {
      const passedCallback = events.play
      delete events.play
      events.play = e => {
        defaultEvents.play.call(null, e)
        passedCallback.call(null, e)
      }
    }
    events.playbackRateChanged = e => {
      defaultEvents.playbackRateChanged.call(null, e)
    }
    events.volume = e => {
      defaultEvents.volume.call(null, e)
    }
    Object.entries(events).map(([evt, callback], _) => {
      player.on(evt, e => callback(e))
    })
  } else {
    Object.entries(defaultEvents).map(([evt, callback], _) => {
      player.on(evt, e => callback(e))
    })
  }
  return player
}
